"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDefaultAvoOptions = void 0;
const types_1 = require("./types");
const setupAmplitude_1 = require("../setupAmplitude");
const frontend_env_1 = require("@cultureamp/frontend-env");
const createLogEventFunctions_1 = __importDefault(require("../createLogEventFunctions"));
const createUserPropertyFunctions_1 = __importDefault(require("../createUserPropertyFunctions"));
/**
 * Provides sensible default Avo options for `Avo.initAvo`. Refers to this for example usage {@link https://github.com/cultureamp/node-packages/tree/master/packages/amplitude#one-off-set-up}
 * @param {string} avoInspectorApiKey - API key for Avo Inspector. It will be exported from the auto-generated Avo.ts file. This needs to be provided since each source would have different API key
 */
const getDefaultAvoOptions = (avoInspectorApiKey = setupAmplitude_1.defaultAvoInspectorApiKey) => {
    const { realm } = (0, frontend_env_1.determineEnvironment)();
    // setUpAmplitude with inspector API key since when using Avo, teams would
    // always use different source rather than default web source
    // otherwise default avo inspector API key (for web source) would be used
    const setUpAmplitudeWithInspectorKey = () => (0, setupAmplitude_1.setupAmplitudeMemo)(avoInspectorApiKey);
    const { logEvent, logEventWithGroups, createOrUpdateGroup, addCurrentUserToGroup, } = (0, createLogEventFunctions_1.default)(setUpAmplitudeWithInspectorKey);
    const { setUserProperties, unidentifyUser } = (0, createUserPropertyFunctions_1.default)(setUpAmplitudeWithInspectorKey);
    return [
        // options
        {
            env: realm === "production" ? types_1.AvoEnv.Prod : types_1.AvoEnv.Dev,
            // Instead of providing Avo Inspector here, we wire it up to the Amplitude
            // custom destination below.
            inspector: undefined,
            avoLogger: {
                logDebug: () => false,
                logWarn: (_env, message) => 
                // Silence this warning, since we attach the Avo Inspector to
                // our Amplitude custom destination below
                message === "[avo] Avo Inspector not provided in initAvo() call",
                logError: () => false,
            },
            noop: !!(process.env.JEST_WORKER_ID ||
                process.env.NODE_ENV === "test" ||
                realm === "test"), // sets by Jest https://jestjs.io/docs/environment-variables
        },
        // destinationOptions
        {},
        amplitudeCustomDestination(),
    ];
    function amplitudeCustomDestination() {
        return {
            // wires AvoInspector up to this custom destination
            make: setUpAmplitudeWithInspectorKey,
            logEvent: (eventName, eventProperties) => logEvent(eventName, eventProperties),
            logPage: (pageName, eventProperties) => logEvent(pageName, eventProperties),
            logEventWithGroups: (eventName, eventProperties, groupTypesToGroupIds) => logEventWithGroups(eventName, eventProperties, groupTypesToGroupIds),
            setUserProperties: (userId, userProperties) => setUserProperties(userProperties),
            setGroupProperties: (groupType, groupId, groupProperties) => createOrUpdateGroup(groupType, groupId, groupProperties),
            addCurrentUserToGroup: (groupType, groupId, groupProperties) => addCurrentUserToGroup(groupType, groupId, groupProperties),
            unidentify: unidentifyUser,
        };
    }
};
exports.getDefaultAvoOptions = getDefaultAvoOptions;
//# sourceMappingURL=avo-options.js.map